import { useWithdrawFromPortfolioMutation } from 'hooks/mutations/Rewards/useWithdrawFromPortfolioMutation'
import { BaseErrorResponse } from 'types/beneficiaries'
import { PortfolioTransportResponse, WithdrawalRequest } from 'types/rewards'
import { useRewardsTracking } from '../useRewardsTracking'

export const useRewardsWithdraw = ({
  isRemoveAllocation = false,
  onSuccess,
  onError,
}: {
  isRemoveAllocation: boolean
  onSuccess: (data: PortfolioTransportResponse) => void
  onError: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useRewardsTracking()

  const { mutate: withdrawFromPortfolio, isPending: isRewardsWithdrawPending } =
    useWithdrawFromPortfolioMutation()

  const onRewardsWithdraw = (data: WithdrawalRequest) => {
    const {
      beneficiary: { walletId, amount },
    } = data

    return withdrawFromPortfolio(data, {
      onSuccess: (responseData: PortfolioTransportResponse) => {
        trackSuccess(isRemoveAllocation ? 'removeAllocation' : 'withdraw', {
          amount: responseData.amount,
          currency: responseData.currency,
        })
        onSuccess(responseData)
      },
      onError: (error: BaseErrorResponse) => {
        trackError(isRemoveAllocation ? 'removeAllocation' : 'withdraw', error, {
          walletId,
          amount,
        })
        onError(error)
      },
    })
  }

  return {
    onRewardsWithdraw,
    isRewardsWithdrawPending,
  }
}
